<template>
    <actions-layout>
        <common-content-spacer class="content" height="huge">
            <common-page-header
                :heading="$t('pages.errors.active_session.heading')"
                :content="$t('pages.errors.active_session.content')"
                contentSpacing="small"
            ></common-page-header>

            <common-buttons>
                <common-button
                    :label="$t('pages.errors.active_session.buttons.new_session')"
                    type="secondary"
                    size="large-long"
                    @click="closeSession"
                ></common-button>
                <common-button
                    :label="$t('pages.errors.active_session.buttons.cancel')"
                    type="primary"
                    size="large-long"
                    @click="continueSession"
                ></common-button>
            </common-buttons>
        </common-content-spacer>
    </actions-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import ActionsLayout from 'components/layouts/ActionsLayout'

    export default {
        mixins: [PageWithTitleMixin],

        components: {
            ActionsLayout,
        },

        computed: {
            pageTitle() {
                return this.$t('pages.errors.general_error.title')
            },
        },

        methods: {
            continueSession() {
                this.$router.push({ name: 'auth.signup.practice', query: { inviteSent: true } })
            },

            closeSession() {
                this.$auth.logOut().then(() => {
                    this.$router.go(-1)
                })
            },
        },
    }
</script>

<style lang="scss" scoped>
    .content {
        margin-top: 120px;
        padding-bottom: 200px;
    }
</style>
